module.exports = __webpack_public_path__ + "img/IMG_0079_L_Foamcore.ce7a3be3.jpg";